var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9992 13.4378V16.188C16.9993 16.3849 16.9247 16.5745 16.7905 16.7186C16.6562 16.8627 16.4724 16.9504 16.2759 16.9642C15.9363 16.9881 15.6589 17 15.4438 17C8.57091 17 3 11.4288 3 4.55556C3 4.34089 3.01193 4.06348 3.03578 3.72333C3.04956 3.5269 3.13733 3.34301 3.28139 3.20876C3.42544 3.07452 3.61505 2.99991 3.81196 3H6.56202C6.65849 2.9999 6.75156 3.03567 6.82313 3.10035C6.89471 3.16503 6.93969 3.25401 6.94934 3.35C6.96696 3.52837 6.98356 3.67148 6.99911 3.77933C7.15366 4.85805 7.47041 5.90721 7.93861 6.89122C8.0125 7.04678 7.96428 7.23267 7.82429 7.33222L6.14594 8.53156C7.17232 10.9227 9.07778 12.8282 11.4688 13.8547L12.6665 12.1793C12.7152 12.1106 12.7866 12.0614 12.8682 12.0402C12.9497 12.019 13.0361 12.0272 13.1121 12.0634C14.096 12.5308 15.1448 12.8468 16.223 13.0007C16.3309 13.0162 16.4735 13.0328 16.6508 13.0504C16.7466 13.0603 16.8354 13.1053 16.8999 13.1769C16.9645 13.2485 16.9993 13.3414 16.9992 13.4378Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.cd2404525479bd79cb2fe49f496422de.svg";
export { ForwardRef as ReactComponent };